"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntaxHighlighter = exports.getSyntaxHighlightStyle = exports.initializeSyntaxHighlights = void 0;
var SH = require("react-syntax-highlighter/dist/light");
var SHStyle = require("react-syntax-highlighter/dist/styles/school-book");
var javascript_1 = require("react-syntax-highlighter/dist/languages/javascript");
var css_1 = require("react-syntax-highlighter/dist/languages/css");
var xml_1 = require("react-syntax-highlighter/dist/languages/xml");
var bash_1 = require("react-syntax-highlighter/dist/languages/bash");
var json_1 = require("react-syntax-highlighter/dist/languages/json");
exports.initializeSyntaxHighlights = function () {
    var registerLanguage = SH.registerLanguage;
    registerLanguage('javascript', javascript_1.default);
    registerLanguage('css', css_1.default);
    registerLanguage('xml', xml_1.default);
    registerLanguage('bash', bash_1.default);
    registerLanguage('json', json_1.default);
};
exports.getSyntaxHighlightStyle = function () {
    return SHStyle.default;
};
exports.SyntaxHighlighter = SH.default;
//# sourceMappingURL=index.js.map